function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { AbstractVectorLayer } from '../../mapmodule/domain/AbstractVectorLayer';
/**
 * @class Oskari.mapframework.bundle.mapwfs2.domain.WFSLayer
 *
 * MapLayer of type WFS
 */

export var WFSLayer = /*#__PURE__*/function (_AbstractVectorLayer) {
  function WFSLayer() {
    var _this;
    _classCallCheck(this, WFSLayer);
    _this = _callSuper(this, WFSLayer, arguments);
    /* Layer Type */
    _this._layerType = 'WFS';
    _this._properties = [];
    return _this;
  }
  /* Overriding methods */
  _inherits(WFSLayer, _AbstractVectorLayer);
  return _createClass(WFSLayer, [{
    key: "hasFeatureData",
    value: function hasFeatureData() {
      return true;
    }
  }, {
    key: "isFilterSupported",
    value: function isFilterSupported() {
      return true;
    }
  }, {
    key: "isSupportedSrs",
    value: function isSupportedSrs() {
      return true;
    }
  }, {
    key: "getLayerUrl",
    value: function getLayerUrl() {
      return Oskari.urls.getRoute('GetWFSVectorTile') + "&id=".concat(this.getId(), "&srs={epsg}&z={z}&x={x}&y={y}");
    }
  }, {
    key: "handleDescribeLayer",
    value: function handleDescribeLayer(info) {
      _superPropGet(WFSLayer, "handleDescribeLayer", this, 3)([info]);
      this._properties = info.properties || [];
    }
  }, {
    key: "getGeometryType",
    value: function getGeometryType(raw) {
      if (raw) {
        var _this$_properties$fin;
        return (_this$_properties$fin = this._properties.find(function (p) {
          return p.type === 'geometry';
        })) === null || _this$_properties$fin === void 0 ? void 0 : _this$_properties$fin.rawType;
      }
      return _superPropGet(WFSLayer, "getGeometryType", this, 3)([]);
    }

    /* Layer type specifics */
  }, {
    key: "replaceFeatureId",
    value: function replaceFeatureId() {
      return this._controlData.replaceFeatureId;
    }
  }, {
    key: "getProperties",
    value: function getProperties(all) {
      if (all) {
        return this._properties;
      }
      return this._properties.filter(function (p) {
        return p.type !== 'geometry' && !p.hidden;
      });
    }

    /**
     * @method getFields
     * @deprecated
     * @return {String[]} fields
     */
  }, {
    key: "getFields",
    value: function getFields() {
      Oskari.log('WFSLayer').deprecated('getFields()');
      var selection = this.getPropertySelection();
      return selection.length ? ['__fid'].concat(_toConsumableArray(selection)) : [];
    }

    /**
     * @method getLocales
     * @deprecated
     * @return {String[]} locales
     */
  }, {
    key: "getLocales",
    value: function getLocales() {
      Oskari.log('WFSLayer').deprecated('getLocales()');
      var labels = this.getProperties().map(function (prop) {
        return prop.label || prop.name;
      });
      return labels.length ? ['ID'].concat(_toConsumableArray(labels)) : [];
    }

    /**
     * Returns an formatter object for given field name.
     * The object can have type and params like:
     * {
     *   type: "link",
     *   params: {
     *     label: "Link title"
     *   }
     * }
     * But it can be an empty config if nothing is configured.
     * This is used to instruct GFI value formatting
     * @param {String} field feature property name that might have formatter options configured
     */
  }, {
    key: "getFieldFormatMetadata",
    value: function getFieldFormatMetadata(field) {
      var _this$getProperties$f;
      if (typeof field !== 'string') {
        return {};
      }
      return ((_this$getProperties$f = this.getProperties().find(function (prop) {
        return prop.name === field;
      })) === null || _this$getProperties$f === void 0 ? void 0 : _this$getProperties$f.format) || {};
    }

    /**
     * @method getPropertySelection
     * @return {String[]} propertySelection
     */
  }, {
    key: "getPropertySelection",
    value: function getPropertySelection() {
      return this.getProperties().map(function (prop) {
        return prop.name;
      });
    }

    /**
     * @method getPropertyLabels
     * @return {json} propertyLabels
     */
  }, {
    key: "getPropertyLabels",
    value: function getPropertyLabels() {
      return this.getProperties().reduce(function (labels, prop) {
        labels[prop.name] = prop.label || prop.name;
        return labels;
      }, {});
    }

    /**
     * @method getPropertyTypes
     * @return {json} propertyTypes
     */
  }, {
    key: "getPropertyTypes",
    value: function getPropertyTypes() {
      return this.getProperties().reduce(function (types, prop) {
        types[prop.name] = prop.type;
        return types;
      }, {});
    }

    /**
     * @method setWpsLayerParams
     * @deprecated
     * @param {json} wpsLayerParams
     */
  }, {
    key: "setWpsLayerParams",
    value: function setWpsLayerParams() {
      Oskari.log('WFSLayer').deprecated('setWpsLayerParams');
    }

    /**
     * @method getWpsLayerParams
     * @deprecated
     * @return {json} wpsLayerParams
     */
  }, {
    key: "getWpsLayerParams",
    value: function getWpsLayerParams() {
      var _this$_controlData = this._controlData,
        commonId = _this$_controlData.commonId,
        noDataValue = _this$_controlData.noDataValue;
      return {
        commonId: commonId,
        noDataValue: noDataValue
      };
    }
  }]);
}(AbstractVectorLayer);
Oskari.clazz.defineES('Oskari.mapframework.bundle.mapwfs2.domain.WFSLayer', WFSLayer);